$(document).ready(function () {
  // Handle the quantity change
  $(document).on("click", ".quantity_input_block .increase-qty", function () {
    console.log("clicked");
    let productCard = $(this).parents(".custom_product_data");
    let quantity = parseInt(
      $(productCard).find('input[name="quantity"]').val()
    );
    quantity += 1;
    $(productCard).find('input[name="quantity"]').val(quantity);
    updateTotalPrice(productCard);
  });

  $(document).on("click", ".quantity_input_block .decrease-qty", function () {
    let productCard = $(this).parents(".custom_product_data");
    let quantity = parseInt(
      $(productCard).find('input[name="quantity"]').val()
    );
    if (quantity > 1) {
      quantity -= 1;
    }
    $(productCard).find('input[name="quantity"]').val(quantity);
    updateTotalPrice(productCard);
  });

  $(document).on("submit", 'form[name="customAddToCart"]', function (e) {
    e.preventDefault();
    const $form = $(this);
    const formData = $form.serializeArray();

    customAddToCartProduct(formData, $form);
  });
});

function customAddToCartProduct(formData, $form) {
  let data;
  $form.find("button").attr("disabled", true);
  $form.find(".loading__spinner").removeClass("hidden");

  const hasItemsField = formData.some((field) => field.name === "items");
  if (hasItemsField) {
    const itemsField = formData.find((field) => field.name === "items");
    try {
      data = JSON.parse(itemsField.value);
    } catch (error) {
      console.error("Error parsing 'items' field:", error);
      $form.find("button").attr("disabled", false);
      $form.find(".loading__spinner").addClass("hidden");
      return;
    }
  } else {
    data = {};
    formData.forEach((field) => {
      data[field.name] = field.value;
    });
    data = [data];
  }

  const generatedFormData = {
    items: data,
    sections: ["cart-drawer", "cart-icon-bubble"],
    sections_url: window.location.pathname,
  };

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(generatedFormData),
  })
    .then((response) => {
      if (!response.ok) {
        console.log($form.siblings(".add-to-cart-error-message"));
        if ($form.find(".add-to-cart-error-message").length > 0) {
          $form.find(".add-to-cart-error-message").css("display", "flex");
        }
        if ($form.siblings(".add-to-cart-error-message").length > 0) {
          $form.siblings(".add-to-cart-error-message").css("display", "flex");
        }
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      window.handleFreeGift();
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.renderContents(data);
        cartDrawer.open();
      }
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
    })
    .finally(() => {
      $form.find("button").attr("disabled", false);
      $form.find(".loading__spinner").addClass("hidden");
      if ($("cart-drawer").hasClass("is-empty")) {
        $("cart-drawer").removeClass("is-empty");
      }
    });
}

// Function to calculate and update the total quantity price
function updateTotalPrice(productCard) {
  $(".add-to-cart-error-message").hide();
  let quantity =
    parseInt($(productCard).find('input[name="quantity"]').val()) || 0;
  let productPrice = $(productCard)
    .find(".quantity_input_block")
    .data("product-price");
  if (!productPrice) {
    console.error("Product price not found in data attribute");
    return;
  }
  let totalQuantityPrice = (productPrice * quantity) / 100;
  $(productCard)
    .find(".total_quantity_price")
    .text("$" + totalQuantityPrice.toFixed(2));
}

// PDP Page Add To Cart Functionalities
$(document).ready(function () {
  // Handle size box selection
  $(document).on("click", ".size_box .box", function (e) {
    const $box = $(this);
    if ($box.hasClass("out-of-stock")) {
      return;
    }
    const $sizeBox = $box.closest(".size_box");
    const $selectedBoxes = $sizeBox.find(".box.selected");
    // Check if the click occurred inside the .quantity_input_block
    if ($(e.target).closest(".quantity_input_block").length > 0) {
      return; // Exit if clicked inside .quantity_input_block
    }
    if ($box.hasClass("selected") && $selectedBoxes.length === 1) {
      return;
    }
    $box.toggleClass("selected");
  });

  // Handle Add to Cart form submission
  $(document).on("submit", 'form[name="customPDPAddToCart"]', function (event) {
    event.preventDefault();
    const $form = $(this);

    // Find all selected boxes
    const $selectedBoxes = $(".box.selected");
    const items = [];

    $selectedBoxes.each(function () {
      const $box = $(this);
      const $idInput = $box.find('input[name="id"]');
      const $quantityInput = $box.find(".quantity__input");
      const $productIdInput = $box.find('input[name="product-id"]');

      if ($idInput.length) {
        const id = parseInt($idInput.val(), 10);
        const quantity = $quantityInput.length
          ? parseInt($quantityInput.val(), 10) || 1
          : 1;
        const productId = $productIdInput.length
          ? parseInt($productIdInput.val(), 10)
          : null;

        items.push({ id, quantity, productId });
      }
    });

    // Set the items array as a JSON string in the hidden input field
    const $itemsInput = $form.find('input[name="items"]');
    if ($itemsInput.length) {
      $itemsInput.val(JSON.stringify(items));
    } else {
      console.warn('Hidden input field for "items" not found.');
      return;
    }

    // Serialize form data
    const formData = $form.serializeArray();
    customAddToCartProduct(formData, $form);
  });
});

$(document).ready(function () {
  $(".professional-card .box .more").on("click", function () {
    $(this).closest(".box").addClass("active");
  });

  $(".professional-card .box .less").on("click", function () {
    $(this).closest(".box").removeClass("active");
  });
});

$(document).on("click", ".video-card .play-btn", function () {
  var videoUrl = $(this).data("video");

  // Prevent popup from opening if there is no video
  if (!videoUrl) {
    return;
  }

  var isYouTube =
    videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");

  if (isYouTube) {
    $("#mp4-video").hide();
    $("#youtube-frame")
      .attr("src", videoUrl + "?autoplay=1")
      .show();
  } else {
    $("#youtube-frame").hide();
    $("#mp4-source").attr("src", videoUrl);
    $("#mp4-video")[0].load();
    $("#mp4-video").show();
  }

  $("#video-popup").fadeIn();
});

$("#video-popup .close-btn, #video-popup .close-btn img, #video-popup").click(
  function (e) {
    if (e.target === this) {
      $("#video-popup").fadeOut();
      $("#youtube-frame").attr("src", ""); // Stop YouTube
      $("#mp4-video")[0].pause(); // Stop MP4
    }
  }
);

// $(document).ready(function () {
//   $(".video-card .play-btn").click(function () {
//     var videoUrl = $(this).data("video");
//     var isYouTube =
//       videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");

//     if (isYouTube) {
//       $("#mp4-video").hide();
//       $("#youtube-frame")
//         .attr("src", videoUrl + "?autoplay=1")
//         .show();
//     } else {
//       $("#youtube-frame").hide();
//       $("#mp4-source").attr("src", videoUrl);
//       $("#mp4-video")[0].load();
//       $("#mp4-video").show();
//     }

//     $("#video-popup").fadeIn();
//   });

//   $("#video-popup .close-btn, #video-popup").click(function (e) {
//     if (e.target === this) {
//       $("#video-popup").fadeOut();
//       $("#youtube-frame").attr("src", ""); // Stop YouTube
//       $("#mp4-video")[0].pause(); // Stop MP4
//     }
//   });
// });

// Js for listen Now Popup

$(document).ready(function () {
  $(".listen-btn").click(function (event) {
    event.preventDefault(); // Prevent default action

    $("#popup").fadeIn();
  });

  $(".close-btn, #popup").click(function () {
    $("#popup").fadeOut();
  });

  $(".popup-content").click(function (event) {
    event.stopPropagation(); // Prevent closing when clicking inside the popup
  });
});

// Js for listen Now Popup

$(document).ready(function () {
  $(".listen-btn").click(function (event) {
    event.preventDefault(); // Prevent default action

    $("#popup").fadeIn();
  });

  $(".close-btn, #popup").click(function () {
    $("#popup").fadeOut();
  });

  $(".popup-content").click(function (event) {
    event.stopPropagation(); // Prevent closing when clicking inside the popup
  });
});


$(document).on('click', '.button-close.button--tertiary', function () {
  // Remove class from the info button
  $('.quantity-popover__info-button').removeClass('quantity-popover__info-button--open')
    .attr('aria-expanded', 'false');

  // Add hidden attribute to the info popup
  $('.cart-items__info.global-settings-popup.quantity-popover__info').attr('hidden', true);
});

async function clearCartItems() {
  try {
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });
  } catch (err) {
    console.error('Failed to clear cart:', err);
  }
}

async function removeNonEventCartItems() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const cart = await response.json();
    const items = cart.items || [];

    const removableItems = items.filter(item => {
      const type = (item.product_type || '').trim().toLowerCase();
      return type !== 'event' && type !== 'digital education';
    });

    if (removableItems.length === 0) {
      return false; // Nothing to remove
    }

    for (const item of removableItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
    }

    return true;
  } catch (err) {
    console.error('Failed to remove non-event/digital education items:', err);
  }
}


async function cartHasItems() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const cart = await response.json();
    return cart.items && cart.items.length > 0;
  } catch (err) {
    console.error('Failed to check cart:', err);
    return false; // assume empty if error
  }
}


$(document).ready(function () {
  let wasLoggedIn = window.isCustomerLoggedIn;

  setInterval(async () => {
    // Assume window.isCustomerLoggedIn has changed elsewhere if user logs out
    if (!wasLoggedIn) {
      const hasItems = await cartHasItems();

      if (hasItems) {
        const removed = await removeNonEventCartItems();
        if (removed) {
          window.location.reload();
        }
      }

      wasLoggedIn = false; // Prevents repeated clearing
    }
  }, 2000);
});